/* eslint-disable react/prop-types */
import React from 'react';
import Drawer from '@mui/material/Drawer';
import { useRecoilValue } from 'recoil';
import { mobileAtom } from '../Atoms';

const SidebarBox = function SidebarBox({ widget, openSidebar }) {
  const mobile = useRecoilValue(mobileAtom);
  return (
    <Drawer
      sx={{
        maxWidth: '280px',
        minWidth: '280px',
        //WebkitBoxShadow: openSidebar && '-1100px 1000px 30px 1080px #000000',
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          maxWidth: '280px',
          minWidth: '280px',
          boxSizing: 'border-box',
        },
      }}
      variant={mobile ? 'persistent' : 'permanent'}
      anchor="left"
      open={openSidebar}
    >
      {widget}
    </Drawer>
  );
};

export default SidebarBox;
